import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraRequestType = ({
  options,
  showOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const { errors, touched, handleBlur, setFieldValue } = useFormikContext();

  const handleChange = (_, newValue) => {
    setSelectedOption(newValue);
    setFieldValue("requestType", newValue);
  };

  const hasError = !!touched.requestType && !!errors.requestType;
  const errorMessage =
    hasError && typeof errors.requestType === "string"
      ? errors.requestType
      : "";

  const requestTypeLabel = useMemo(() => {
    const labelText = selectedOption ? "Request type" : "Select request type";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [selectedOption]);

  return (
    <Autocomplete
      options={options || []}
      disabled={!showOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={handleChange}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Typography variant="caption">{option.name}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={requestTypeLabel}
          fullWidth
          required
          error={hasError}
          helperText={errorMessage}
          onBlur={handleBlur}
          InputProps={getTextFieldInputProps(params.InputProps)}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};
export default JiraRequestType;
